import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Thumbnail from '../../Thumbnail';
import { ImageUrl } from '../../../utils/constants';
import { withTranslation } from 'react-i18next';
import { NewChampionsCard, NewVideoPlayer, EventCard, NewContentV2 } from '../../MainEvents/RecommendEventVideos/styles';
import { AdminDeleteIcon, LaunchIcon, RecognitionWarningIcon, VerticalDotsIcon } from '../../../utils/icons';
import { DownAngleV2 } from '../../SocialFeedsV2/styles';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import CommonModal from '../../common/CommonModal/CommonModal';
import { toast } from 'react-toastify';
import { fetchApi } from '../../../utils/methods';
import { DeleteThemEventTemplate } from '../../../redux/constants/apiConstants';

class OnDemandCard extends Component {
  constructor() {
    super();
    this.state = {
      showVideoModal: false,
      showDeleteModal: false,
      templateId:null,
      lastSegment:null,
    }
  }

 


  deleteCategory = async () => {
    const {history}= this.props;
    const TemplateId = this.state.templateId; 
    try {
      const res = await fetchApi(`${DeleteThemEventTemplate}/${TemplateId}`, "DELETE");
      window.console.log("delete moment response",res)
      if (res.status ==="success") {
        toast.success(res.message);
        const pathArray = history.location.pathname.split("/");

        // Get the last segment of the path
        const lastSegment = pathArray[pathArray.length - 1];
        this.props.fetchCompanyOrganizedCatgoryId(lastSegment);

        // getEventDetailsById(event.id)
        // getSharedMoments(companyId, page);
      } else {
        toast.error(res.messgae);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  

  videoModal =() => {
    const { history, video } = this.props;
    history.push({pathname:`/company/events/create-lunch-learns`,state:{isOnDemandEvent:true,eventId:video.id}})
  }



  eventModal =() => {
    const { history,video } = this.props;
    history.push({pathname:`/company/events/create`,state:{isCustomizedEvent:true,eventId:video?.id, title: video?.title, image: video?.image, description: video?.description}})
  }


  openPopup = (post) => {
    
    this.setState({templateId:post?.id ,showDeleteModal: true });
  }

  handleDeleteCancel = () =>{
    this.setState({ showDeleteModal: false });
  }

  handleDeleteConfirm = () => {
    this.deleteCategory();
    this.setState({ showDeleteModal: false });
  }


  render() {
    const { video, grid, onHover, onEnterMouse, onLeaveMouse, length, t, isCompanyOraganizedEvent,history,templateId } = this.props;
    const { showDeleteModal } = this.state;
    const cardLength = length + 1;
    return (
      <NewChampionsCard grid={grid} margin={(cardLength) % 3 == 0 ? "0px" : "25px"}>
        <EventCard videoCSS={grid} onMouseEnter={() => onEnterMouse(video.id)} onMouseLeave={() => onLeaveMouse()}>
          <NewVideoPlayer>
            <Thumbnail
              src={isCompanyOraganizedEvent ? `${ImageUrl}/${video.image}` :`${ImageUrl}/${video.thumbnail_image}`}
              alt={video.title}
            />
          </NewVideoPlayer>
          {onHover === video.id &&
            <div className='educateImageBackground' onClick={isCompanyOraganizedEvent ? ()=>this.eventModal() : () => this.videoModal()}>
              <div className="getStarted">
                {LaunchIcon()}
                {t("Launch Event")}
              </div>
            </div>
          }
          <NewContentV2 newPadding={'newPadding'} style={{minHeight:'auto'}}>
            <div className='firstContainer' style={{display:'flex', justifyContent:'space-between'}}>
              <div className='name' title={video?.title}>
                {t(video.title)}
              </div>
              {isCompanyOraganizedEvent ? <DownAngleV2 feed>
                <DropdownButton id="editDelete" title={<VerticalDotsIcon/>}>
                  <Dropdown.Item  onClick={() => history.push({pathname:`/company/events/edit-theme-event`,state:{video:video,templateId:templateId}})} >
                    {t("Edit event")}
                  </Dropdown.Item>
                  <Dropdown.Item   onClick={() => this.openPopup(video)}>
                    {t("Delete event")}
                  </Dropdown.Item>
                 
                </DropdownButton>
              </DownAngleV2> : null}
              {/* <div>stepsNameHighlight</div> */}
            </div>
          </NewContentV2>
        </EventCard>
        {showDeleteModal && <CommonModal
          show={showDeleteModal}
          icon={RecognitionWarningIcon("#C13D4D")}
          title="Delete theme event"
          description="Are you sure you want to delete this event?"
          subDescription="This action cannot be undone, and the event will be permanently removed from the system."
          onCancel={this.handleDeleteCancel}
          onConfirm={this.handleDeleteConfirm}
          cancelText="Keep event"
          confirmButtonText="Delete Permanently"
          buttonIcon={AdminDeleteIcon()}
          confirmButtonWidth="198px"
          modalHeight="244px"
          descriptionColor="#CE7841"
          isPopupMargin={"-10px 0 20px 0"}
        />
        }
      </NewChampionsCard>
    );
  }
}
OnDemandCard.propTypes = {
  video: PropTypes.object,
  grid: PropTypes.number,
  onHover: PropTypes.number,
  onEnterMouse: PropTypes.func.isRequired,
  onLeaveMouse: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  length: PropTypes.number,
  t: PropTypes.func,
  isCompanyOraganizedEvent: PropTypes.bool,
  fetchCompanyOrganizedCatgoryId: PropTypes.func,
  templateId: PropTypes.number,
};

export default (withTranslation()(OnDemandCard));